export default __webpack_public_path__ + "static/media/teste_logo.adb59ea9.png";